import * as api from "services/api";
import { getErrors } from "helpers/error";

export const GET_COMPANY_PROVIDER =
	"[COMPANY_PROVIDER_DETAIL] GET_COMPANY_PROVIDER";
export const GET_COMPANY_PROVIDER_ERROR =
	"[COMPANY_PROVIDER_DETAIL] GET_COMPANY_PROVIDER_ERROR";
export const GET_COMPANY_PROVIDER_SUCCESS =
	"[COMPANY_PROVIDER_DETAIL] GET_COMPANY_PROVIDER_SUCCESS";

export const DELETE_COMPANY_PROVIDER =
	"[COMPANY_PROVIDER DELETE] DELETE_COMPANY_PROVIDER";
export const DELETE_COMPANY_PROVIDER_ERROR =
	"[COMPANY_PROVIDER DELETE] DELETE_COMPANY_PROVIDER_ERROR";
export const DELETE_COMPANY_PROVIDER_SUCCESS =
	"[COMPANY_PROVIDER DELETE] DELETE_COMPANY_PROVIDER_SUCCESS";

export const DELETE_PROVIDER_BENEFITS =
	"[PROVIDER_BENEFITS DELETE] DELETE_PROVIDER_BENEFITS";
export const DELETE_PROVIDER_BENEFITS_ERROR =
	"[PROVIDER_BENEFITS DELETE] DELETE_PROVIDER_BENEFITS_ERROR";
export const DELETE_PROVIDER_BENEFITS_SUCCESS =
	"[PROVIDER_BENEFITS DELETE] DELETE_PROVIDER_BENEFITS_SUCCESS";

export const GET_COMPANY_PROVIDER_HISTORY =
	"[COMPANY_PROVIDER_DETAIL] GET_COMPANY_PROVIDER_HISTORY";
export const GET_COMPANY_PROVIDER_HISTORY_ERROR =
	"[COMPANY_PROVIDER_DETAIL] GET_COMPANY_PROVIDER_HISTORY_ERROR";
export const GET_COMPANY_PROVIDER_HISTORY_SUCCESS =
	"[COMPANY_PROVIDER_DETAIL] GET_COMPANY_PROVIDER_HISTORY_SUCCESS";

export const SET_VALUE = "[COMPANY_PROVIDER_DETAIL] SET_VALUE";
export const CLEAR_VALUES = "[COMPANY_PROVIDER_DETAIL] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getCompanyProviderById(id, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_COMPANY_PROVIDER
		});

		try {
			const { login } = getState();

			let response = await api.sendGet(`/companyprovider/${id}`, {
				Authorization: "Bearer " + login.token
			});

			let result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_COMPANY_PROVIDER_SUCCESS,
					payload: result.model
				});
				callback && callback(null, result.model);
			} else {
				dispatch({
					type: GET_COMPANY_PROVIDER_ERROR,
					payload: getErrors(result.errors)
				});
			}
		} catch (error) {
			return dispatch({
				type: GET_COMPANY_PROVIDER_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function deleteCompanyProvider(id, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: DELETE_COMPANY_PROVIDER
		});

		try {
			const { login } = getState();

			let response = await api.sendDelete(`/companyProvider/${id} `, {
				Authorization: "Bearer " + login.token
			});

			let result = await response.json();

			if (result.isValid) {
				dispatch({
					type: DELETE_COMPANY_PROVIDER_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: DELETE_COMPANY_PROVIDER_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);

			return dispatch({
				type: DELETE_COMPANY_PROVIDER_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function deleteProviderBenefits(id, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: DELETE_PROVIDER_BENEFITS
		});

		try {
			const { login } = getState();

			let response = await api.sendDelete(
				`/companyProvider/provider-benefits/${id} `,
				{
					Authorization: "Bearer " + login.token
				}
			);

			let result = await response.json();

			if (result.isValid) {
				dispatch({
					type: DELETE_PROVIDER_BENEFITS_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: DELETE_PROVIDER_BENEFITS_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);

			return dispatch({
				type: DELETE_PROVIDER_BENEFITS_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function getProviderHistory(
	companyProviderId,
	skip,
	take,
	filter,
	sort,
	desc,
	callback = null
) {
	return async (dispatch, getState) => {
		try {
			dispatch({
				type: GET_COMPANY_PROVIDER_HISTORY
			});

			const { login } = getState();

			let response = await api.sendGet(
				`/companyProvider/history/${companyProviderId}?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${filter ||
					"&filters=null"}`,
				{
					Authorization: "Bearer " + login.token
				}
			);

			let result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_COMPANY_PROVIDER_HISTORY_SUCCESS,
					payload: result.model
				});

				if (result.params) {
					dispatch(
						setValue({
							pages: Math.ceil(result.params.count / take),
							...result.params
						})
					);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_COMPANY_PROVIDER_HISTORY_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);

			return dispatch({
				type: GET_COMPANY_PROVIDER_HISTORY_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
